import { render, staticRenderFns } from "./AgendaItem.vue?vue&type=template&id=93e7052e"
import script from "./AgendaItem.vue?vue&type=script&lang=js"
export * from "./AgendaItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports